import Vue from "vue";
import cloudinary from "cloudinary-core";

import { cloudinaryConfig } from "./config";

// filters: takes a value {{ value | formatToTime }} and returns processed value

Vue.filter("resizeImage", (value, { height = 125, width = 512, crop = "fill", radius = 0 }) => {
  if (typeof value !== "string" || value.indexOf("http") !== 0) {
    window.console.log("value here");
    return value;
  }

  // eslint-disable-next-line @typescript-eslint/camelcase
  const cl = new cloudinary.Cloudinary({ cloud_name: cloudinaryConfig.cloudName, secure: true });
  const image = cl.url(value, {
    type: "fetch",
    height,
    width,
    crop,
    radius
  });
  return image;
});
